module.exports = __webpack_public_path__ + "img/bx_font_o.7f804301.png";